import { BaseService } from './base.service';

export class MallService extends BaseService {
    baseUrl = '/mall';
}
